import api from './axios';

// Allocation Center
export const getAllocationDashboard = () => api.get('/allocation-center/dashboard');
export const getAllocationCharts = () => api.get('/allocation-center/dashboard/charts');
export const submitAllocation = (data) => api.post('/allocation-center/wizard/submit', data);

// Employee Portfolio
export const getEmployeePortfolio = (employeeId) => api.get(`/employee-portfolio/${employeeId}`);
export const getEmployeeSummary = (employeeId) => api.get(`/employee-portfolio/${employeeId}/summary`);

// Loan Center
export const getLoanDashboard = () => api.get('/loan-center/dashboard');
export const createLoan = (data) => api.post('/loan-center/create', data);
export const closeLoan = (loanId, data) => api.post(`/loan-center/${loanId}/close`, data);

// Transfer Center
export const getTransferDashboard = () => api.get('/transfer-center/dashboard');
export const submitTransfer = (data) => api.post('/transfer-center/wizard/submit', data);

// Return Center
export const getReturnDashboard = () => api.get('/return-center/dashboard');
export const submitReturn = (data) => api.post('/return-center/complete', data);
export const submitReturnRequest = (data) => api.post('/return-center/request', data);

// Reservation Center
export const getReservations = (params) => api.get('/reservation-center', { params });
export const createReservation = (data) => api.post('/reservation-center', data);

// Inventory Intelligence
export const getInventoryStatus = () => api.get('/inventory-intelligence/status-breakdown');
export const getInventoryUtilization = () => api.get('/inventory-intelligence/utilization');
export const getInventoryTrends = () => api.get('/inventory-intelligence/trends');

// Bulk Operations
export const validateBulk = (data) => api.post('/bulk-operations/validate', data);
export const executeBulk = (data) => api.post('/bulk-operations/execute', data);

// QR Codes
export const generateQR = (assetId) => api.get(`/qr-codes/${assetId}`);
export const generateBulkQR = (assetIds) => api.post('/qr-codes/bulk', { assetIds });
export const generateBulkQRPdf = (assetIds) => api.post('/qr-codes/bulk/pdf', { assetIds }, { responseType: 'blob' });
export const scanQR = (content) => api.post('/qr-codes/scan', { content });

// Label Printing
export const getLabelAssetIds = (params) => api.get('/qr-codes/asset-ids', { params });
export const generateLabels = (assetIds) => api.post('/qr-codes/labels', { assetIds });
export const generateLabelsPdf = (assetIds, symbology, orientation, opts = {}) =>
  api.post('/qr-codes/labels/pdf', { assetIds, symbology, orientation, ...opts }, { responseType: 'blob' });
export const generateCustomLabelsPdf = (values, symbology, orientation, opts = {}) =>
  api.post('/qr-codes/labels/custom/pdf', { values, symbology, orientation, ...opts }, { responseType: 'blob' });

// Return Center - Photos & Certificate
export const uploadReturnPhotos = (returnId, formData) => api.post(`/return-center/${returnId}/photos`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getReturnCertificate = (returnId) => api.get(`/return-center/${returnId}/certificate`, { responseType: 'blob' });

// Operations Hub
export const getOperationsHubSummary = () => api.get('/operations-hub/summary');

// Reports Export
export const getReport = (type, params) => api.get(`/assets/reports/${type}`, { params });
export const exportReportCSV = (type, params) => api.get(`/assets/reports/${type}/export-csv`, { params, responseType: 'blob' });
